import $ from 'jquery';
import 'jfilestyle';

$(document).ready(function () {
    $(':file').each(function (index, element) {
        const $input = $(element);
        const $inputContainer = $input.parents('.field');
        const placeholder = $inputContainer.data('placeholder');
        $input.jfilestyle({
            text: selectrum.upload_text,
            placeholder: placeholder,
            inputSize: '100%'
        });
    })

});